import { IStatus } from './../Models/status';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PostService {

  constructor(private http: HttpClient) { }
  GetPosts(id: string): Observable<IStatus> {
    let param = new HttpParams();
    param = param.append('id', id);
    return this.http.get<IStatus>('api/Post/GetPosts', {params: param});
  }
}
